import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getMycaApiUrl = createConfigSelector('mycaApiUrl');
